/**
 * @desc Directive that renders a stack frame and creates a link to open source docs
 * @example
 * <cs-vulnerability-stack-trace frame="frame" language="language"/>
 */
;(function () {
  angular
    .module('contrast.vulnerabilities')
    .directive('csVulnerabilityStackTrace', csVulnerabilityStackTrace)

  function csVulnerabilityStackTrace() {
    'ngInject'

    return {
      templateUrl:
        'components/vulnerabilities/cs-vulnerability-stack-trace-template.html',
      bindToController: {
        frame: '=frame',
        language: '=language'
      },
      restrict: 'E',
      controller: 'csVulnerabilityStackTraceCtrl',
      controllerAs: 'csVulnerabilityStackTraceCtrl'
    }
  }
})()
